import { Form, Input } from "antd";
import ContentLayout from "../components/layout/ContentLayout";
import MyBreadcrumb from "../components/layout/MyBreadcrumb";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import Button from "../components/Button";
import { useTranslation } from "react-i18next";

export default function SettingsAccountPass() {
  const { t } = useTranslation();

  return (
    <ContentLayout
      header={
        <>
          <h1>{t("change_password")}</h1>
          <MyBreadcrumb />
        </>
      }
    >
      <Form className="rewards-form pass-form" layout="vertical">
        <div className="rewards-form-section">
          <div className="rewards-inputs">
            <Form.Item
              name="currentPassword"
              label={t("current_password")}
              required
            >
              <Input.Password
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
              />
            </Form.Item>
            <Form.Item name="pass1" label={t("new_password")} required>
              <Input.Password
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
              />
            </Form.Item>
            <Form.Item name="pass2" label={t("confirm_password")} required>
              <Input.Password
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
              />
            </Form.Item>

            <ul>
              <li>{t("password_rule_1")}</li>
              <li>{t("password_rule_1")}</li>
              <li>{t("password_rule_1")}</li>
              <li>{t("password_rule_1")}</li>
              <li>{t("password_rule_1")}</li>
            </ul>

            <Form.Item className="rewards-form-btn">
              <Button>{t("save")}</Button>
            </Form.Item>
          </div>
        </div>
      </Form>
    </ContentLayout>
  );
}
